import { useState } from "react";

export default function Booking() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    car: "",
    pickup: "",
    startDate: "",
    endDate: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendWhatsApp = () => {
    if (!form.name || !form.phone || !form.car || !form.pickup || !form.startDate || !form.endDate) {
      alert("Please fill all details");
      return;
    }

    const message = `
Hello, I want to book a car

Name: ${form.name}
Phone: ${form.phone}
Car: ${form.car}
Pickup Location: ${form.pickup}
From: ${form.startDate}
To: ${form.endDate}

Please confirm availability.
`;

    const whatsappNumber = "919052885299"; // CHANGE TO YOUR NUMBER
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <section className="booking-header">
        <h1>Book Your Car</h1>
        <p>Fill the form below and confirm your booking instantly via WhatsApp</p>
      </section>

      <section className="glass-section booking-form">
        <div className="form-grid">
          <input type="text" name="name" placeholder="Full Name" onChange={handleChange} />
          <input type="tel" name="phone" placeholder="Phone Number" onChange={handleChange} />

          <select name="car" onChange={handleChange}>
            <option value="">Select Car</option>
            <option>Hyundai Creta</option>
            <option>Honda City</option>
            <option>Innova Crysta</option>
            <option>Maruti Brezza</option>
            <option>Swift Dzire</option>
          </select>

          <input type="text" name="pickup" placeholder="Pickup Location" onChange={handleChange} />

          <input type="date" name="startDate" onChange={handleChange} />
          <input type="date" name="endDate" onChange={handleChange} />
        </div>

        <button className="btn-gradient booking-btn" onClick={sendWhatsApp}>
          Confirm Booking on WhatsApp
        </button>
      </section>
    </>
  );
}
